<div class="row g-4">
  <app-harbour-dues-rotterdam-pro-forma-table header="Vessel" [data]="[{}]">
    <ng-template proFormaColumn="Gross tonnage" [type]="ColumnType.VALUE">
      <app-skeleton />
    </ng-template>
    <ng-template proFormaColumn="Operation" [type]="ColumnType.OPERATION">
      &times;
    </ng-template>
    <ng-template proFormaColumn="Rate" [type]="ColumnType.VALUE">
      <app-skeleton width="3rem" />
    </ng-template>
    <ng-template proFormaColumn="Amount" [type]="ColumnType.LINE_TOTAL">
      <app-skeleton width="7rem" />
    </ng-template>
    
    <ng-template proFormaSubTotal>
      <app-skeleton width="8rem" />
    </ng-template>
  </app-harbour-dues-rotterdam-pro-forma-table>

  <app-harbour-dues-rotterdam-pro-forma-table header="Cargo" [data]="cargoTypes()">
    <ng-template proFormaColumn="Cargo type" [type]="ColumnType.DESCRIPTION">
      <app-skeleton />
    </ng-template>
    <ng-template proFormaColumn="Tonnage" [type]="ColumnType.VALUE">
      <app-skeleton width="3rem" />
    </ng-template>
    <ng-template proFormaColumn="Operation" [type]="ColumnType.OPERATION">
      &times;
    </ng-template>
    <ng-template proFormaColumn="Rate" [type]="ColumnType.VALUE">
      <app-skeleton width="3rem" />
    </ng-template>
    <ng-template proFormaColumn="Amount" [type]="ColumnType.LINE_TOTAL">
      <app-skeleton width="7rem" />
    </ng-template>

    <ng-template proFormaDiscountLabel>
      <span>Efficiency discount</span>
    </ng-template>
    <ng-template proFormaDiscountValue>
      <app-skeleton width="7rem" />
    </ng-template>

    <ng-template proFormaSubTotal>
      <app-skeleton width="8rem" />
    </ng-template>
  </app-harbour-dues-rotterdam-pro-forma-table>

  <app-harbour-dues-rotterdam-pro-forma-table header="Sustainability" [data]="[{}]">
    <ng-template proFormaColumn="Gross tonnage" [type]="ColumnType.VALUE">
      <app-skeleton />
    </ng-template>
    <ng-template proFormaColumn="Operation" [type]="ColumnType.OPERATION">
      &times;
    </ng-template>
    <ng-template proFormaColumn="Rate" [type]="ColumnType.VALUE">
      <app-skeleton width="3rem" />
    </ng-template>
    <ng-template proFormaColumn="Amount" [type]="ColumnType.LINE_TOTAL">
      <app-skeleton width="7rem" />
    </ng-template>

    <ng-template proFormaDiscountLabel>
      <app-skeleton width="8rem" />
    </ng-template>
    <ng-template proFormaDiscountValue>
      <app-skeleton width="7rem" />
    </ng-template>
    <ng-template proFormaDiscountLabel>
      <app-skeleton width="12rem" />
    </ng-template>
    <ng-template proFormaDiscountValue>
      <app-skeleton width="7rem" />
    </ng-template>

    <ng-template proFormaSubTotal>
      <app-skeleton width="8rem" />
    </ng-template>
  </app-harbour-dues-rotterdam-pro-forma-table>

  <app-harbour-dues-rotterdam-pro-forma-table header="Waste disposal" [data]="[{}]">
    <ng-template proFormaColumn="Fixed base fee" [type]="ColumnType.VALUE">
      <app-skeleton width="4rem" />
    </ng-template>
    <ng-template proFormaColumn="Operation" [type]="ColumnType.OPERATION">
      +
    </ng-template>
    <ng-template proFormaColumn="Gross tonnage" [type]="ColumnType.VALUE">
      <app-skeleton width="3rem" />
    </ng-template>
    <ng-template proFormaColumn="Operation" [type]="ColumnType.OPERATION">
      &times;
    </ng-template>
    <ng-template proFormaColumn="Rate" [type]="ColumnType.VALUE">
      <app-skeleton width="3rem" />
    </ng-template>
    <ng-template proFormaColumn="Amount" [type]="ColumnType.LINE_TOTAL">
      <app-skeleton width="7rem" />
    </ng-template>

    <ng-template proFormaSubTotal>
      <app-skeleton width="8rem" />
    </ng-template>
  </app-harbour-dues-rotterdam-pro-forma-table>

  <footer class="mt-5 mt-mb-4">
    <dl class="row mb-0">
      <dt class="col-6 col-md-12 mb-md-2 mb-0 fw-regular text-md-end">
        Grand total
      </dt>
        <dd class="col-6 col-md-12 mb-0 fw-regular text-end">
      <app-skeleton width="8rem" />
        </dd>
    </dl>
  </footer>
</div>